import { render, staticRenderFns } from "./edit-company.vue?vue&type=template&id=5130e1c6&"
import script from "./edit-company.vue?vue&type=script&lang=js&"
export * from "./edit-company.vue?vue&type=script&lang=js&"
import style0 from "./edit-company.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports